export default __webpack_public_path__ + "static/media/bg.878e48e1.jpg";